export default __webpack_public_path__ + "static/media/Ecesis-Tech.e27d682f.gif";